// extracted by mini-css-extract-plugin
module.exports = {"outer":"Upload_outer_1qTaZ","label":"Upload_label_1jbDT","small__btn":"Upload_small__btn_18N8K","file":"Upload_file_2JdTP","icon":"Upload_icon_2IzGm"};